import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { dispatchEvent } from 'src/helpers/tagManager'

import styles from './BaseButton.module.scss'

const defaultProps = {
  element: 'button',
  onClick: () => {},
  role: 'button',
  trackOptions: {},
  trackEnabled: true
}

const propTypes = {
  // attach a class to the button so the container can position or modify
  className: PropTypes.string,

  // render something other than a 'button' tag, such as an anchor
  element: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.shape({ render: PropTypes.func.isRequired })
  ]),

  // will be composed if tracking is enabled
  onClick: PropTypes.func,

  role: PropTypes.string,

  // Calls dispatchEvent with this just before onClick handler fires
  track: PropTypes.string,

  // Additional tracking info for track prop
  trackOptions: PropTypes.object,

  trackEnabled: PropTypes.bool
}

const BaseButton = React.forwardRef(
  (
    {
      className,
      element: Element,
      onClick,
      track,
      trackEnabled,
      trackOptions,
      ...restProps
    },
    ref
  ) => (
    <Element
      className={classnames(styles.root, className)}
      ref={ref}
      onClick={
        track && trackEnabled
          ? (...args) => {
              dispatchEvent(track, trackOptions)
              onClick(...args)
            }
          : onClick
      }
      {...restProps}
    />
  )
)

BaseButton.defaultProps = defaultProps
BaseButton.propTypes = propTypes

export default BaseButton
